import { CheckCircleIcon } from '@heroicons/react/20/solid'
import Support from "../img/support-clotere.webp"

const features = [
  {
    name: 'Un conseiller Clotere dédié à votre dossier.',
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis suscipit eaque, iste dolor cupiditate blanditiis ratione.',
    icon: CheckCircleIcon,
  },
  {
    name: 'Assistance juridique illimité',
    description: 'Anim aute id magna aliqua ad ad non deserunt sunt. Qui irure qui lorem cupidatat commodo.',
    icon: CheckCircleIcon,
  },
  {
    name: 'Echanges et support Whatsapp 24/24',
    description: 'Ac tincidunt sapien vehicula erat auctor pellentesque rhoncus. Et magna sit morbi lobortis.',
    icon: CheckCircleIcon,
  },
  {
    name: 'Des guides et articles sans jargon juridique pour mieux comprendre !',
    description: 'Ac tincidunt sapien vehicula erat auctor pellentesque rhoncus. Et magna sit morbi lobortis.',
    icon: CheckCircleIcon,
  },
]

export default function Example() {
  const startChat = () => {
    if (window.Intercom) {
      // Affiche le widget
      window.Intercom('show');

      // Lance une nouvelle conversation
      window.Intercom('startConversation');
    }
  };
  return (
    <div className="overflow-hidden bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pt-4 lg:pr-8">
            <div className="lg:max-w-lg">
              <h2 className="text-base/7 font-semibold text-indigo-600">On vous accompagne de A à Z</h2>
              <p className="mt-2 text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl">
                Un support sans faille pour vos démarches
              </p>
              <dl className="mt-10 max-w-xl space-y-4 text-base/7 text-gray-600 lg:max-w-none">
                {features.map((feature) => (
                  <div key={feature.name} className="relative pl-9">
                    <dt className="inline font-semibold text-gray-900">
                      <feature.icon aria-hidden="true" className="absolute top-1 left-1 size-5 text-indigo-600" />
                      {feature.name}
                    </dt>
                  </div>
                ))}
              </dl>
            </div>
          </div>
          <img
            alt="Un support sans faille pour vos démarches notariales"
            src={Support}
            width={2432}
            height={1442}
            className=""
          />
        </div>
      </div>
      <div className='mx-auto max-w-7xl px-6 lg:px-8 text-center mt-10'>
      <button onClick={startChat} className="w-[40%] mx-auto no-underline btn-main  !bg-gradient-to-r !from-indigo-300 !to-indigo-800">
      👋 Posez votre question à un notaire
    </button>
      </div>
    </div>
  )
}
